// Collision-proof id generator for visuals / report pages.
// `Date.now()` alone collides when two ids are minted in the same millisecond
// (fast add / duplicate / bulk-drop). Colliding ids made two distinct visuals
// alias the same `visualResults[id]` slot, so editing one blanked the other.
// The monotonic counter guarantees uniqueness within a session.
let __idCounter = 0;
export function genId(prefix = '') {
  __idCounter = (__idCounter + 1) % 1000000000;
  return `${prefix}${Date.now().toString(36)}${__idCounter.toString(36)}`;
}
